function a(t, e) {
  if (t.url.indexOf("http") === 0)
    return new URL(t.url);
  {
    let r = `${t.url.indexOf("/") > -1 ? "" : "/"}${t.url}`;
    if (e)
      return new URL(`https://www.frontiersin.org${r}`);
    if (!t.url.startsWith("/")) {
      const n = window.location.pathname.split("/"), u = !t.url.startsWith("?") && !t.url.startsWith("#"), s = u ? "/" : "";
      u && n.pop(), r = `${n.join("/")}${s}${t.url}`;
    }
    const o = location.port !== "80" ? ":" + location.port : "";
    return new URL(
      `${location.protocol}//${window.location.hostname}${o}${r}`
    );
  }
}
function i(t) {
  return t.useNuxtRouter === void 0 || t.useNuxtRouter === !0;
}
function c(t, e, r, o) {
  !o && !t.url || (o || (o = a(t, r)), t.url && window.$nuxt && t.target !== "_blank" && i(t) && (window.location.host, o.host));
}
export {
  a as g,
  c as l
};
